import { render, staticRenderFns } from "./MoleculeCreateEditContactPointOrSale.vue?vue&type=template&id=308c1be4&scoped=true&"
import script from "./MoleculeCreateEditContactPointOrSale.vue?vue&type=script&lang=js&"
export * from "./MoleculeCreateEditContactPointOrSale.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeCreateEditContactPointOrSale.vue?vue&type=style&index=0&id=308c1be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c1be4",
  null
  
)

export default component.exports